module.exports = __webpack_public_path__ + "assets/img/img310.6c85ec81.png";